import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycAreThereDifferentTypesOfProbateInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-are-there-different-types-of-probate-in-new-york/']} />;
}
